import {
  CandidateAssessmentAnswer,
  CandidateAssessmentDetail,
  CandidateData,
} from '$types/candidates';
import SPKShowcaseCandidateInfo from '../SPKShowcaseCandidateInfo/SPKShowcaseCandidateInfo';

/** The endpoint returns the answers unsorted, SortOrder carries the intent */
const bySortOrder = (
  a: CandidateAssessmentAnswer,
  b: CandidateAssessmentAnswer
) => a.SortOrder - b.SortOrder;

const PROMPT_CLASSNAMES = 'p-3 rounded-xl border border-[#E6EAF0] bg-[#F8FAFD]';
const LABEL_CLASSNAMES =
  'block mb-[5px] text-[10px] leading-[1.2] font-extrabold';
const TEXT_CLASSNAMES =
  'text-[#5F625C] text-xs leading-[1.6] font-medium whitespace-pre-line';

const SPKEmployerShowcaseAssessmentsModal = ({
  assessments,
  title,
  candidate,
}: {
  assessments: CandidateAssessmentDetail[];
  title: string;
  candidate: CandidateData;
}) => {
  return (
    <div className="flex flex-col overflow-auto bg-white py-5 px-4 rounded-2xl w-full">
      <SPKShowcaseCandidateInfo candidate={candidate} />
      <div className="mb-4 text-spk-highContrast text-base font-bold">
        {title}
      </div>
      <div className="grid gap-3.5">
        {assessments.map((detail, detailIndex) => (
          <article
            key={detail.Id}
            className="p-[18px] rounded-2xl border border-[#E0E6EF] bg-white"
          >
            <div className="flex items-center gap-2.5 mb-3.5">
              <span className="grid place-items-center shrink-0 w-7 h-7 rounded-[9px] bg-[#EEF3FF] text-[#2563EB] text-[11px] font-black">
                {detailIndex + 1}
              </span>
              <h4 className="mt-px text-[#101828] text-sm leading-[1.35] font-extrabold">
                {detail.Title}
              </h4>
            </div>
            <div className="flex flex-col gap-3.5">
              {[...detail.Assessments].sort(bySortOrder).map((answer) => (
                <div key={answer.Id}>
                  <div className="grid gap-3 mb-3 md:grid-cols-[minmax(0,1.35fr)_minmax(220px,0.65fr)]">
                    <div className={PROMPT_CLASSNAMES}>
                      <strong className={`${LABEL_CLASSNAMES} text-[#667085]`}>
                        The Situation
                      </strong>
                      <p className={TEXT_CLASSNAMES}>{answer.Situation}</p>
                    </div>
                    <div className={PROMPT_CLASSNAMES}>
                      <strong className={`${LABEL_CLASSNAMES} text-[#667085]`}>
                        Task
                      </strong>
                      <p className={TEXT_CLASSNAMES}>{answer.Task}</p>
                    </div>
                  </div>
                  <div className="p-3.5 rounded-xl border border-[#CDEFEA] bg-[#F0FBF9]">
                    <span className={`${LABEL_CLASSNAMES} text-[#08746D]`}>
                      Candidate Answer
                    </span>
                    <p className={TEXT_CLASSNAMES}>{answer.Answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default SPKEmployerShowcaseAssessmentsModal;
